/**
 * Static-translations for th. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const th = {
  'anon.heading_default': 'ดำเนินการต่อในฐานะแขก',
  'anon.try_again': 'ลองอีกครั้ง',
  'auth.back_to_login': 'กลับไปที่หน้าเข้าสู่ระบบ',
  'auth.check_email_message': 'ตรวจสอบอีเมลของคุณเพื่อรับรหัสยืนยัน',
  'auth.check_email_title': 'ตรวจสอบอีเมลของคุณ',
  'auth.confirm_email_title': 'ยืนยันอีเมลของคุณ',
  'auth.confirmation_code': 'รหัสยืนยัน',
  'auth.continue_with_apple': 'ดำเนินการต่อด้วย Apple',
  'auth.continue_with_facebook': 'ดำเนินการต่อด้วย Facebook',
  'auth.continue_with_github': 'ดำเนินการต่อด้วย GitHub',
  'auth.continue_with_google': 'ดำเนินการต่อด้วย Google',
  'auth.create_account': 'สร้างบัญชี',
  'auth.default_subtitle': 'เข้าสู่ระบบเพื่อเข้าถึงฟีเจอร์ทั้งหมดและซิงค์ข้อมูลของคุณ',
  'auth.email': 'ที่อยู่อีเมล',
  'auth.email_already_registered': 'อีเมลนี้ลงทะเบียนไว้แล้ว เข้าสู่ระบบด้านล่างด้วยรหัสผ่านหรือบัญชีที่คุณใช้สมัคร',
  'auth.email_exists': 'มีบัญชีที่ใช้อีเมลนี้อยู่แล้ว',
  'auth.email_not_confirmed': 'โปรดยืนยันอีเมลของคุณก่อน',
  'auth.forgot_password': 'ลืมรหัสผ่าน?',
  'auth.forgot_password_title': 'ลืมรหัสผ่าน?',
  'auth.forgot_subtitle': 'ใส่อีเมลของคุณแล้วเราจะส่งลิงก์รีเซ็ตรหัสผ่านให้คุณ',
  'auth.generic_error': 'มีบางอย่างผิดพลาด',
  'auth.have_account': 'มีบัญชีอยู่แล้ว?',
  'auth.hide_password': 'ซ่อนรหัสผ่าน',
  'auth.identity_already_linked': 'บัญชีนี้ลงทะเบียนไว้แล้ว เข้าสู่ระบบด้วยบัญชีนี้ด้านล่าง',
  'auth.invalid_credentials': 'อีเมลหรือรหัสผ่านไม่ถูกต้อง',
  'auth.invalid_otp': 'รหัสไม่ถูกต้องหรือหมดอายุ',
  'auth.last_used': 'ใช้ล่าสุด · {email}',
  'auth.last_used_no_email': 'ใช้ล่าสุด',
  'auth.link_purchase_subheading': 'เราจะเชื่อมโยงการซื้อกับบัญชีของคุณเพื่อรักษาการเข้าถึง',
  'auth.log_in': 'เข้าสู่ระบบ',
  'auth.log_in_link': 'เข้าสู่ระบบ',
  'auth.login_continue_purchase': 'เข้าสู่ระบบเพื่อดำเนินการซื้อต่อ',
  'auth.network_error': 'เกิดข้อผิดพลาดของเครือข่าย โปรดตรวจสอบการเชื่อมต่อแล้วลองอีกครั้ง',
  'auth.no_account': 'ยังไม่มีบัญชี?',
  'auth.or': 'หรือ',
  'auth.password': 'รหัสผ่าน',
  'auth.passwords_mismatch': 'รหัสผ่านไม่ตรงกัน',
  'auth.rate_limited': 'มีคำขอมากเกินไป โปรดลองอีกครั้งภายหลัง',
  'auth.repeat_password': 'ยืนยันรหัสผ่าน',
  'auth.reset_link_valid': 'ลิงก์มีอายุ 1 ชั่วโมง',
  'auth.reset_password_title': 'รีเซ็ตรหัสผ่าน',
  'auth.reset_sent_message': 'หากอีเมลนี้มีอยู่ ระบบได้ส่งรหัสรีเซ็ตแล้ว',
  'auth.reset_sent_subtitle': 'เราได้ส่งลิงก์รีเซ็ตรหัสผ่านแล้ว ทำตามคำแนะนำในอีเมล',
  'auth.restore_purchases_heading': 'คืนค่าการซื้อ',
  'auth.restore_purchases_subheading': 'กรุณาเข้าสู่ระบบเพื่อคืนค่าการซื้อของคุณ',
  'auth.send_reset': 'ส่งอีเมลรีเซ็ต',
  'auth.service_unavailable': 'บริการไม่พร้อมใช้งานชั่วคราว โปรดลองอีกครั้งภายหลัง',
  'auth.show_password': 'แสดงรหัสผ่าน',
  'auth.sign_out': 'ออกจากระบบ',
  'auth.sign_up': 'สมัครสมาชิก',
  'auth.sign_up_link': 'สมัครสมาชิก',
  'auth.signed_in': 'เข้าสู่ระบบแล้ว',
  'auth.signin_failed': 'เข้าสู่ระบบไม่สำเร็จ',
  'auth.signup_failed': 'สมัครสมาชิกไม่สำเร็จ',
  'auth.verify': 'ยืนยัน',
  'auth.weak_password': 'รหัสผ่านอ่อนเกินไป',
  'auth.welcome': 'ยินดีต้อนรับ!',
  'auth.welcome_signup': 'ยินดีต้อนรับ!',
  'countdown.d': 'ว',
  'countdown.h': 'ชม',
  'countdown.m': 'นาที',
  'countdown.s': 'วิ',
  'cta.close': 'ปิด',
  'cta.continue': 'ดำเนินการต่อ',
  'cta.get_lifetime_access': 'รับสิทธิ์ตลอดชีพ',
  'cta.get_plan_daily': 'รับแผนรายวัน',
  'cta.get_plan_monthly': 'รับแผนรายเดือน',
  'cta.get_plan_weekly': 'รับแผนรายสัปดาห์',
  'cta.get_plan_yearly': 'รับแผนรายปี',
  'cta.start_trial': 'เริ่มทดลองใช้ฟรี {days} วัน',
  'modal.close_aria': 'ปิด',
  'modal.continue': 'ดำเนินการต่อ',
  'modal.error_generic': 'มีบางอย่างผิดพลาด',
  'modal.loading': 'กำลังโหลด…',
  'modal.purchase_restored_subtitle': 'ทุกอย่างพร้อมแล้ว — ขอให้สนุก!',
  'modal.purchase_restored_title': 'ยินดีต้อนรับกลับ',
  'modal.purchase_success_subtitle': 'ทุกอย่างพร้อมแล้ว — ขอให้สนุก!',
  'modal.purchase_success_title': 'รับการชำระเงินแล้ว',
  'modal.verifying_subscription': 'กำลังตรวจสอบการสมัครสมาชิก…',
  'nav.back': '← กลับ',
  'nav.back_aria': 'กลับ',
  'offer.limited_time': 'ข้อเสนอช่วงเวลาจำกัด',
  'payment.awaiting_title': 'ทำการชำระเงินให้เสร็จในแท็บใหม่',
  'payment.checking': 'กำลังตรวจสอบ…',
  'payment.ive_paid': 'ฉันชำระเงินแล้ว',
  'payment.open_checkout_again': 'เปิดการชำระเงินอีกครั้ง',
  'payment.open_checkout_button': 'เปิดการชำระเงิน',
  'pricing.free_trial_days': 'ทดลองใช้ฟรี {days} วัน',
  'pricing.included_per': 'รวมต่อ {interval}:',
  'pricing.interval.day': 'วัน',
  'pricing.interval.lifetime_short': 'ตลอดชีพ',
  'pricing.interval.month': 'เดือน',
  'pricing.interval.period': 'งวด',
  'pricing.interval.week': 'สัปดาห์',
  'pricing.interval.year': 'ปี',
  'pricing.money_back': 'รับประกันคืนเงิน 30 วัน',
  'pricing.most_popular': 'ยอดนิยม',
  'pricing.no_prices': 'ไม่มีราคา',
  'pricing.plan_label.daily': 'แผนรายวัน',
  'pricing.plan_label.lifetime': 'ตลอดชีพ',
  'pricing.plan_label.monthly': 'แพ็กเกจรายเดือน',
  'pricing.plan_label.weekly': 'แพ็กเกจรายสัปดาห์',
  'pricing.plan_label.yearly': 'แพ็กเกจรายปี',
  'pricing.plans_aria': 'แผน',
  'session.contact_support': 'ติดต่อฝ่ายสนับสนุน',
  'session.restore_purchases': 'กู้คืนการซื้อ',
  'session.sign_out': 'ออกจากระบบ',
  'session.signed_in_as_prefix': 'เข้าสู่ระบบในชื่อ',
  'session.signing_out': 'กำลังออกจากระบบ…',
  'support.attachments_label': 'ไฟล์แนบ',
  'support.close_button': 'ปิด',
  'support.done_button': 'เสร็จสิ้น',
  'support.email_placeholder': 'ใส่อีเมลของคุณ',
  'support.heading': 'การสนับสนุน',
  'support.instruction': 'กรุณากรอกแบบฟอร์มด้านล่างเพื่อส่งคำขอสนับสนุนของคุณ',
  'support.invalid_email': 'อีเมลไม่ถูกต้อง',
  'support.message_length': '1–5000 ตัวอักษร',
  'support.message_placeholder': 'ใส่ข้อความของคุณ',
  'support.required': 'จำเป็น',
  'support.send_another': 'ส่งคำขออีกครั้ง',
  'support.send_button': 'ส่ง',
  'support.sending': 'กำลังส่ง…',
  'support.subject_length': '3–200 ตัวอักษร',
  'support.subject_placeholder': 'ใส่หัวข้อของคุณ',
  'support.success_heading': 'ส่งคำขอแล้ว',
  'support.success_message_prefix': 'เราได้รับข้อความของคุณแล้วและจะตอบกลับไปที่'
} as const;

export default th;
